import { SetupContext, Ref, ref, onUnmounted } from '@vue/composition-api'

function useVuex<T>(context: SetupContext, getState: () => T): Ref<T> {
  // 最後に as Ref<T> をしておかないと data.value の更新の部分で型エラーが起きました
  const data = ref<T>(getState()) as Ref<T>

  const unwatch = context.root.$store.watch<T>(getState, (newVal: T) => {
    // refのvalueを更新すればコンポーネントが反応する
    data.value = newVal
  })

  onUnmounted(() => {
    unwatch()
  })

  // Refを返す
  return data
}

export default useVuex
